import { useContext } from "react";
import { notification } from "antd";
import { deleteRequest, getRequest, handleResponse, patchFormRequest, patchFormRequests, patchRequest, postFormRequest, postFormRequests } from "../../context/requestTypes";
import { AxiosContext } from "../../context/AxiosContext";
import { useMutation, useQuery } from "react-query";
import { useRecoilValue } from "recoil";
import authAtom from "../../atoms/auth/auth.atom";



export function useGetAllBusiness(params, key) { // /api/v1/Business/GetAllBusinessAccounts
  const url = "/Business/GetAllBusinessAccounts"; 
  const axios = useContext(AxiosContext);
  return useQuery(["key:get_all_Business", ...(key||[])?.map(d => params?.[d])], () => getRequest(axios, url, params), {
    onSuccess: (response) => handleResponse(response),
    onError: (error) => notification.error({
      message: "Error!",
      description: error?.message ? (Object.entries(error?.errors || {key:[error?.message]})?.map(([,value]) => value?.join(", ")))?.join(", ") : "something went wrong please check internet connection.",
    }),
  });
}

export function useGetPaymentMethods(params, key) { // /api/v1/Business/GetPaymentMethods
  const url = "/Business/GetPaymentMethods"; 
  const axios = useContext(AxiosContext);
  return useQuery(["key:get_all_PaymentMethod", ...(key||[])?.map(d => params?.[d])], () => getRequest(axios, url, params), {
    onSuccess: (response) => handleResponse(response),
    // onError: (error) => notification.error({
    //   message: "Error!",
    //   description: error?.message ? (Object.entries(error?.errors || {key:[error?.message]})?.map(([,value]) => value?.join(", ")))?.join(", ") : "something went wrong please check internet connection.",
    // }),
  });
}

export function useGetBusiness(successAction) {
  const url = "/Business/GetBusiness/";
  const axios = useContext(AxiosContext);
  return useMutation((id) => getRequest(axios, url+id), {
    onSuccess: (response) => handleResponse(response, () => successAction?.()),
    onError: (error) => notification.error({
      message: "Error!",
      description: error?.message ? (Object.entries(error?.errors || {key:[error?.message]})?.map(([,value]) => value?.join(", ")))?.join(", ") : "something went wrong please check internet connection.",
    }),
  });
}

export function useGetVendor(successAction) { // /api/v1/Business/GetVendorProfile/{userId}
  const url = "/Business/GetVendorProfile/";
  const axios = useContext(AxiosContext);
  return useMutation((id) => getRequest(axios, url+id), {
    onSuccess: (response) => handleResponse(response, () => successAction?.()),
    onError: (error) => notification.error({
      message: "Error!",
      description: error?.message ? (Object.entries(error?.errors || {key:[error?.message]})?.map(([,value]) => value?.join(", ")))?.join(", ") : "something went wrong please check internet connection.",
    }),
  });
}

export function useGetVendSubHistory(successAction) { // /api/v1/Business/GetVendorRatings/{vendorId}
  const url = "/Business/GetVendorSubscriptionHistory/";
  const axios = useContext(AxiosContext);
  return useMutation((id) => getRequest(axios, url+id), {
    onSuccess: (response) => handleResponse(response, () => successAction?.()),
    onError: (error) => notification.error({
      message: "Error!",
      description: error?.message ? (Object.entries(error?.errors || {key:[error?.message]})?.map(([,value]) => value?.join(", ")))?.join(", ") : "something went wrong please check internet connection.",
    }),
  });
}

export function useGetVendorRatings(successAction) { // /api/v1/Business/GetVendorRatings/{vendorId}
  const url = "/Business/GetVendorRatings/";
  const axios = useContext(AxiosContext);
  return useMutation((id) => getRequest(axios, url+id), {
    onSuccess: (response) => handleResponse(response, () => successAction?.()),
    onError: (error) => notification.error({
      message: "Error!",
      description: error?.message ? (Object.entries(error?.errors || {key:[error?.message]})?.map(([,value]) => value?.join(", ")))?.join(", ") : "something went wrong please check internet connection.",
    }),
  });
}

export function usePostBusiness(successAction) { // /api/v1/Business/CreateBusinessAccount
    const url = "/Business/CreateBusinessAccount"; 
    const { user } = useRecoilValue(authAtom)
    return useMutation((payload) => postFormRequests(url, payload, user?.token), {
      onSuccess: (response) => {
        handleResponse(response, () => {
          successAction?.()
          notification.success({
            message: "Success!",
            description: response?.message || "action successful",
          })
        })
      },
      onError: (error) => notification.error({
        message: "Error!",
        description: error?.message ? (Object.entries(error?.errors || {key:[error?.message]})?.map(([,value]) => value?.join(", ")))?.join(", ") : "something went wrong please check internet connection.",
      }),
    });
  }

  export function useDeleteBusiness(successAction) {
    const url = `/Business/DeleteBusiness/`; 
    const axios = useContext(AxiosContext);
    return useMutation((id) => deleteRequest(axios, url+id), {
      onSuccess: (response) => {
        handleResponse(response, () => {
          successAction?.()
          notification.success({
            message: "Success!",
            description: response?.message || "action successful",
          })
        })
      },
      onError: (error) => notification.error({
        message: "Error!",
        description: error?.message ? (Object.entries(error?.errors || {key:[error?.message]})?.map(([,value]) => value?.join(", ")))?.join(", ") : "something went wrong please check internet connection.",
      }),
    });
  }

  export function usePatchBusiness(successAction) {
    const url = `/Business/EditBusiness/`; 
    const axios = useContext(AxiosContext);
    return useMutation((payload) => patchRequest(axios, url+payload?.id, payload), {
      onSuccess: (response) => {
        handleResponse(response, () => {
          successAction?.()
          notification.success({
            message: "Success!",
            description: response?.message || "action successful",
          })
        })
      },
      onError: (error) => notification.error({
        message: "Error!",
        description: error?.message ? (Object.entries(error?.errors || {key:[error?.message]})?.map(([,value]) => value?.join(", ")))?.join(", ") : "something went wrong please check internet connection.",
      }),
    });
  }

  export function usePatchPaymentMethod(successAction) {
    const url = `/Business/EditPaymentMethod/`; 
    const axios = useContext(AxiosContext);
    return useMutation((payload) => patchRequest(axios, url+payload?.id, payload), {
      onSuccess: (response) => {
        handleResponse(response, () => {
          successAction?.()
          notification.success({
            message: "Success!",
            description: response?.message || "action successful",
          })
        })
      },
      onError: (error) => notification.error({
        message: "Error!",
        description: error?.message ? (Object.entries(error?.errors || {key:[error?.message]})?.map(([,value]) => value?.join(", ")))?.join(", ") : "something went wrong please check internet connection.",
      }),
    });
  }

export function usePatchBlog(successAction) {  // /api/v1/Business/EditPaymentMethod/{paymentMethodId}
  const url = "/Blog/EditPaymentMethod/"; 
  const { user } = useRecoilValue(authAtom)
  return useMutation((payload) => patchFormRequest(url+payload?.id, payload, user?.token), {
    onSuccess: (response) => {
      handleResponse(response, () => {
        successAction?.()
        notification.success({
          message: "Success!",
          description: response?.message || "action successful",
        })
      })
    },
    onError: (error) => notification.error({
      message: "Error!",
      description: error?.message ? (Object.entries(error?.errors || {key:[error?.message]})?.map(([,value]) => value?.join(", ")))?.join(", ") : "something went wrong please check internet connection.",
    }),
  });
}